import React from 'react';

export default function ActiveTicketItem({ ticket, isActive, onSelect }) {
  const hasUnread = ticket.has_unread || false;
  const unreadCount = ticket.unread_count || 0;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(ticket)}
      style={{
        padding: '10px 12px',
        borderRadius: '8px',
        border: isActive ? '0.5px solid #85B7EB' : '0.5px solid #dee2e6',
        background: isActive ? '#E6F1FB' : '#f8f8f6',
        marginBottom: '6px',
        cursor: 'pointer',
        outline: 'none',
        transition: 'background 0.15s',
      }}
    >
      {/* Nome + unread badge */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginBottom: '4px' }}
      >
        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
          {hasUnread && (
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: '#185FA5',
                animation: 'pulse 2s ease-in-out infinite',
                flexShrink: 0,
              }}
            />
          )}
          <span
            style={{
              fontSize: '12px',
              fontWeight: 600,
              color: isActive ? '#0C447C' : '#3d3d3a',
            }}
          >
            {ticket.customer_name || ticket.customer_phone || 'Cliente'}
          </span>
        </div>

        {hasUnread && unreadCount > 0 && (
          <span
            style={{
              background: '#185FA5',
              color: '#fff',
              fontSize: '9px',
              padding: '1px 6px',
              borderRadius: '8px',
              minWidth: '16px',
              textAlign: 'center',
            }}
          >
            {unreadCount}
          </span>
        )}
      </div>

      {/* Pedido */}
      {ticket.order_number && (
        <div
          style={{
            fontSize: '11px',
            color: isActive ? '#0C447C' : '#5F5E5A',
            marginBottom: '4px',
          }}
        >
          Pedido #{ticket.order_number}
        </div>
      )}

      {/* Subscriber + Loja */}
      <div
        className="d-flex align-items-center"
        style={{ gap: '4px', flexWrap: 'wrap' }}
      >
        {ticket.subscriber_name && (
          <span
            style={{
              fontSize: '10px',
              color: isActive ? '#3C3489' : '#5F5E5A',
              background: isActive
                ? 'rgba(206,203,246,0.4)'
                : 'rgba(0,0,0,0.05)',
              padding: '1px 6px',
              borderRadius: '8px',
            }}
          >
            {ticket.subscriber_name}
          </span>
        )}
        {ticket.store_name && (
          <span
            style={{
              fontSize: '10px',
              color: isActive ? '#085041' : '#888780',
              background: isActive
                ? 'rgba(159,225,203,0.3)'
                : 'rgba(0,0,0,0.03)',
              padding: '1px 6px',
              borderRadius: '8px',
            }}
          >
            {ticket.store_name}
          </span>
        )}
      </div>
    </div>
  );
}
